Vue.component("add-basket-cross", {
  props: {
    item: {
      type: Object,
      required: true
    },
    varationcrossData: {
      type: Array,
      required: true
    },
    isItem: {   
      type: Boolean,
      default: false  
    }
  },
  data() {
    return {
      selectedVariationId: null
    };
  },
  created() {
    /*if (this.varationcrossData.length > 0) {
      this.selectedVariationId = this.varationcrossData[0].data.variation.id;
    }*/
    this.selectedVariationId = this.item.variation.id;
  },
  methods: {
    switchVariation(variation) {
    
       this.selectedVariationId = variation.variation.id;

        const productThumb = this.$el.closest(".cmp-product-thumb");
        const single = this.$el.closest(".single");

        if (productThumb != null){
          // Preis
          const priceEl = productThumb.querySelector(".price");
          if (priceEl && variation.prices?.default?.unitPrice?.formatted) {
            priceEl.textContent = variation.prices.default.unitPrice.formatted;
          }

          // Crossprice nur wenn RRP existiert
          const crossEl = productThumb.querySelector(".crossprice");
          if (crossEl && variation.prices?.rrp?.price?.formatted) {
            crossEl.textContent = `UVP ${variation.prices.rrp.price.formatted}`;
          } else if (crossEl) {
            // Wenn kein RRP vorhanden → Crossprice ausblenden oder leeren
            crossEl.textContent = "";
          }

          // Einheit Content
          const unitContentEl = productThumb.querySelector(".cat-unit-content");
          if (unitContentEl && variation.unit?.content) {
            unitContentEl.textContent = variation.unit.content;
          }

          // Einheit Name
          const unitNameEl = productThumb.querySelector(".cat-unit-name");
          if (unitNameEl && variation.unit?.names?.name) {
            unitNameEl.textContent = variation.unit.names.name;
          }

          // Baseprice
          const basePriceEl = productThumb.querySelector(".cat-unit-baseprice");
          if (basePriceEl && variation.prices?.default?.basePrice) {
            basePriceEl.textContent = variation.prices.default.basePrice;
          }
        } 
      
        if(single != null){
          const priceEl = single.querySelector(".price > span");
          if (priceEl && variation.prices?.default?.unitPrice?.formatted) {
            priceEl.textContent = variation.prices.default.unitPrice.formatted;
          }

          // Crossprice nur wenn RRP existiert
          const crossEl = single.querySelector(".crossprice > del");
          if (crossEl && variation.prices?.rrp?.price?.formatted) {
            crossEl.textContent = `UVP ${variation.prices.rrp.price.formatted}`;
          } else if (crossEl) {
            // Wenn kein RRP vorhanden → Crossprice ausblenden oder leeren
            crossEl.textContent = "";
          }

          // Einheit Content
          const unitContentEl = single.querySelector(".base-price > div");
          if (unitContentEl && variation.unit?.content) {
            unitContentEl.innerHTML = `Inhalt <span>${ variation.unit.content }</span> <span>${ variation.unit.names.name }</span>`;
          }

          

          // Baseprice
          const basePriceEl = single.querySelector(".base-price-value");
          if (basePriceEl && variation.prices?.default?.basePrice) {
            basePriceEl.textContent = variation.prices.default.basePrice;
          }
        }

         
    }
  }
});
